/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Owner_EmailInputs */

const cs_auth_signup_owner_email = /** @type {(inputs: Auth_Signup_Owner_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail majitele`)
};

const en_auth_signup_owner_email = /** @type {(inputs: Auth_Signup_Owner_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner email`)
};

/**
* | output |
* | --- |
* | "Owner email" |
*
* @param {Auth_Signup_Owner_EmailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_owner_email = /** @type {((inputs?: Auth_Signup_Owner_EmailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Owner_EmailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_owner_email(inputs)
	return cs_auth_signup_owner_email(inputs)
});